import { getCurrentUser } from "store";

import { useAppSelector } from "hooks/redux";

const useIsAuthenticated = () => Boolean(useAppSelector(getCurrentUser));

export default useIsAuthenticated;
